// TODO: Add authentication / disallow write access for everyone
export const firebaseConfig = {
  apiKey: "AIzaSyAuoxV0p_Z8Xe8B85okZff4Xf3lAol501o",
  authDomain: "eduvision-living-library.firebaseapp.com",
  databaseURL:
    "https://eduvision-living-library-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "eduvision-living-library",
  storageBucket: "eduvision-living-library.appspot.com",
  messagingSenderId: "226974366663",
  appId: "1:226974366663:web:37f8256e1a11bf3e83b7e2",
};
